// ProfileLink là text ứng viên/TA tự nhập trên SharePoint, và nó được đưa
// thẳng vào href.
//
// esc() cũ chặn được XSS qua ký tự HTML nhưng KHÔNG chặn được scheme:
// "javascript:alert(1)" không chứa & < > " ' nên đi qua nguyên vẹn và thành
// link chạy code khi có người bấm. React cũng không chặn giúp — nó chỉ escape
// nội dung, không kiểm scheme của href.
//
// Nên href phải qua hàm này. Link không hợp lệ → undefined, chỗ gọi render
// tên ứng viên dạng text thường thay vì thẻ <a>.

const SAFE_SCHEMES = ["http:", "https:", "mailto:"];

export function safeHref(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  try {
    // base = origin để link tương đối ("/sites/…") vẫn hợp lệ.
    const parsed = new URL(url, window.location.origin);
    return SAFE_SCHEMES.includes(parsed.protocol) ? url : undefined;
  } catch {
    return undefined; // không parse được → không phải link
  }
}
